export const PARTIES = {
  D: 'Democratic',
  R: 'Republican',
  G: 'Green'
};

export const NEIGHBORHOODS = {
  d1: 'Lower Manhattan',
  d2: 'East Village to Murray Hill',
  d4: 'East Side and Midtown',
  d6: 'Upper West Side',
  d8: 'East Harlem and South Bronx',
  d9: 'Harlem',
  d13: 'Northeast Bronx',
  d14: 'Morris Heights to Kingsbridge',
  d18: 'Clason Point to Parkchester',
  d20: 'Flushing and Murray Hill',
  d21: 'East Elmhurst and Corona',
  d28: 'Rochdale and South Ozone Park',
  d35: 'Clinton Hill to Crown Heights',
  d38: 'Red Hook and Sunset Park',
  d40: 'Prospect Lefferts Gardens to Kensington',
  d41: 'Ocean Hill to East Flatbush',
  d43: 'Bay Ridge to Bath Beach',
  d49: 'North Shore of Staten Island',
};



// WEBPACK FOOTER //
// ./app/src/js/lib/lookup-tables.js